import { FC } from 'react';

interface Props {
  total_views: number;
  userVote: number | null;
  votingInProgress: boolean;
  handleDownvote: () => Promise<void>;
  handleUpvote: () => Promise<void>;
}

const PromptCardViews: FC<Props> = ({ total_views, userVote, votingInProgress, handleDownvote, handleUpvote }) => {
  return (
    <div className='flex items-center gap-2'>
      {/* Voting buttons */}
      <div className="flex items-center gap-1">
        <button
          data-testid="upvote-button"
          onClick={handleUpvote}
          className={`${userVote === 1 ? 'text-brand-electric-blue' : 'text-gray-500 hover:text-brand-electric-blue'} ${votingInProgress ? 'opacity-50 cursor-wait' : ''} transition-colors duration-200`}
          aria-label="Upvote"
          disabled={votingInProgress}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
          </svg>
        </button>

        <button
          data-testid="downvote-button"
          onClick={handleDownvote}
          className={`${userVote === -1 ? 'text-red-500' : 'text-gray-500 hover:text-red-500'} ${votingInProgress ? 'opacity-50 cursor-wait' : ''} transition-colors duration-200`}
          aria-label="Downvote"
          disabled={votingInProgress}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </button>
      </div>

      {/* Views count */}
      <div className="flex items-center bg-brand-light-gray rounded-full px-3 py-1 text-brand-dark-blue text-sm font-medium">
        <span className="font-semibold">{total_views} views</span>
      </div>
    </div>
  );
};

export default PromptCardViews;
